import React, { useState, useEffect } from 'react';
import { AiFillHome } from "react-icons/ai";
import ContactForm from '../../components/ContactForm/ContactForm';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import { getTenantBranding } from '../../api/api';
import './Appointment.scss';

const Appointment = () => {
    const [mapLink, setMapLink] = useState('https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d158857.72810807265!2d-0.24168024584704212!3d51.52877184047419!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f131!3m3!1m2!1s0x47d8a00baf21de75%3A0x52963a5addd52a99!2sLondon%2C%20UK!5e0!3m2!1sen!2sbd!4v1666254073802!5m2!1sen!2sbd');
    const [locationName, setLocationName] = useState('35 West Dental Street California 1004');
    // const [mapLink, setMapLink] = useState(
    //   "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3692.3889642316067!2d70.78093907596093!3d22.263251079713257!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3959ca5c64054dd5%3A0x2c3d8c54d3e8eb43!2sDr.%20Govani%20Teeth%20Mouth%20and%20Jaw%20Hospital!5e0!3m2!1sen!2sin!4v1754243599184!5m2!1sen!2sin"
    // );
    
    useEffect(() => {
        const fetchTenantBranding = async () => {
            try {
                const brandingData = await getTenantBranding();
                console.log(brandingData);
                if (brandingData) {
                    if (brandingData.map_link) {
                        setMapLink(brandingData.map_link);
                    }
                    if (brandingData.location_name) {
                        setLocationName(brandingData.location_name);
                    }
                }
            } catch (error) {
                console.error('Error fetching tenant branding:', error);
                // Keep default values if API call fails
            }
        };

        fetchTenantBranding();
    }, []);

    return (
      <section
        className="appointment-section pb-70 pt-100"
        data-aos="fade-up"
        data-aos-duration="2000"
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-5 col-md-6">
              <div className="google-map">
                <iframe title="map" src={mapLink}></iframe>

                <div className="location-name">
                  <AiFillHome />
                  <p>{locationName}</p>
                </div>
              </div>
            </div>
            <div className="col-lg-7 col-md-6">
              <div className="appointment-form-area">
                {/* <SectionTitle
                  subTitle="BOOK APPOINTMENT"
                  title="Care is pleasure"
                  description="Experience gentle, personalized dental care in a comfortable and welcoming environment. Your smile and well-being are our top priorities!"
                /> */}

                <ContactForm />
              </div>
            </div>
          </div>
        </div>
      </section>
    );
};

export default Appointment;